<template>
  <van-nav-bar title="学生住宿信息确认" @click-left="onClickLeft" />
  <van-divider content-position="left">学生信息</van-divider>
  <van-row :gutter="10">
    <van-col span="10">学号：{{ ruleForm.datas.student_No }}</van-col>
    <van-col span="14">姓名：{{ ruleForm.datas.student_Name }}</van-col>
  </van-row>
  <van-row :gutter="10" style="border-bottom: 1px solid #f2f2f2;">
    <van-col span="10">性别：{{ ruleForm.datas.student_Sex }}</van-col>
    <van-col span="14">身份证号：{{ ruleForm.datas.student_IDnumber }}</van-col>
  </van-row>
   <van-divider content-position="left">住宿信息</van-divider>
  <van-row :gutter="10">
    <van-col span="10"
      >公寓： {{ ruleForm.datas.student_BuildingName }}</van-col
    >
    <van-col span="14">房间：{{ ruleForm.datas.student_Room }} 房间</van-col>
  </van-row>
  <van-row :gutter="10" style="border-bottom: 1px solid #f2f2f2;">
    <van-col span="10"
      >床位： {{ ruleForm.datas.student_Cwname }} 号床位</van-col
    >
  </van-row>
 <div style="margin: 16px;" :class="{submitselect: active}" >   
    <van-field type="hidden" name="id" v-model="ruleForm.datas.id" />
    <van-button block square type="primary" @click="onSubmit(ruleForm.datas.id)" native-type="submit">确认办理住宿</van-button>
</div>
<div style="margin: 16px;" :class="{submitselect: !active}" >   
      <van-row gutter="20">
        <p class="center">请继续扫码办理下一位！</p>
      </van-row>
</div>
</template>
<style>
.submitselect{
    display: none;
}
.van-grid-item {
  text-align: left;
  padding-left: 10px;
}
.van-row{
  border-top: 1px solid #f2f2f2;
}
.van-checkbox{ padding: 5px;}
.van-col {
  color: var(--van-grid-item-text-color);
  font-size: var(--van-grid-item-text-font-size);
  line-height: 1.5;
  word-break: break-all;
  border-right: 1px solid #f2f2f2;
  padding: 10px 5px;
  text-align: left;
}
.van-collapse-item__content{
  padding: 0px;
}
  .center{
    text-align: center;
    margin: 0 auto;
  }
</style>
<script>
import { Toast } from "vant";
import {  reactive } from "vue";
import { getStudentByID } from "../../http/api.manage.ts";
import { ConfirmRoomSave } from "../../http/api.manage.ts";
import { baseurl } from "../../http/api.ts";
import { ref } from "vue";
import { useRoute } from "vue-router";
export default {
  setup() {
    let ruleForm = reactive({
      datas: []
    });
    const route = useRoute();
    let active = ref("");
    let dataFun = async () => {
      await getStudentByID(route.query.idnumber).then((res) => {
        ruleForm.datas = res.datas;
        ruleForm.datas.student_Photo = baseurl + ruleForm.datas.student_Photo;
     });          
    };
    dataFun();
    return {
      ruleForm,
      active
    };
  },
  methods: {   
    onClickLeft() {
      history.go(-1);
    },
    onSubmit(values){       
      ConfirmRoomSave(values).then((res) => {
        if (res.code == 200) {
          Toast.success(res.msg);
          this.active=true;
        } else {
          Toast.fail(res.msg);
        }
      });
    }
  }
};
</script>